export default __webpack_public_path__ + "static/media/americanWest.c23a989c.png";